import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import "./ClientInvoice.css";
import blankProfile from "../../../img/hotgig-loading.png";
import moment from "moment"
import { ProfileType } from "../../../types/enum";
class ClientInvoice extends Component {
    render() {
        const data = this.props.data;
        return (
            <Grid>
                <table>
                    <tbody><tr>
                        <td className="header-left-col">
                            <table>
                                <tbody><tr>
                                    <td className="logo-container">
                                        <img className="avatar" src={data.profileImage ? data.profileImage : blankProfile} />
                                    </td>
                                    <td>
                                        <span className="invoice-creator" style={{paddingLeft: 20}}>
                                            {data.invoiceCreator}
                                        </span>
                                    </td>
                                </tr>
                                </tbody></table>
                        </td>
                        <td className="header-right-col tax-invoice">
                            Tax Invoice
              </td>
                    </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                {data.addressLine1}
                            </td>
                            <td className="header-right-col">
                                Date: {data.createdDate}
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                {data.addressLine2}
                            </td>
                            <td className="header-right-col">
                                Invoice#: HG-{data.invoiceNumber}
              </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                {data.phoneNumber}
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                <a href="">{data.emailAddress}</a>
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                ABN: {data.abnNumber}
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                To: {data.recipientName}
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                <a href="">{data.recipientEmail}</a>
                            </td>
                        </tr>
                        <tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                {data.recipientAddressLine1}
                            </td>
                        </tr><tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                {data.recipientSuburb}
                            </td>
                        </tr><tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                {data.recipientAddressLine2}
                            </td>
                        </tr><tr>
                            <td className="header-left-col">
                                &nbsp;
              </td>
                            <td className="header-right-col">
                                {data.recipientPhoneNumber}
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
                <table><tbody>
                    <tr>
                        <td className="invoice-row-fee">
                            {data.purchaseOrderCode ? `Purchase Order` : ""}
                        </td>
                        <td className="invoice-row-fee">
                            &nbsp;
              </td>
                        <td className="invoice-row-fee">
                            &nbsp;
              </td>
                        <td className="invoice-row-fee">
                            Payment Terms
              </td>
                        <td className="invoice-row-fee">
                            Due Date
              </td>
                    </tr>
                    <tr>
                        {data.purchaseOrderCode ?
                            <td className="bordered-cell invoice-summary-cell-left">{data.purchaseOrderCode}</td> :
                            <td className="invoice-row-fee">&nbsp;</td>
                        }
                        <td className="invoice-row-fee">&nbsp;</td>
                        <td className="invoice-row-fee">&nbsp;</td>
                        <td className="bordered-cell invoice-summary-cell">
                            {data.paymentTerms}
                        </td>
                        <td className="bordered-cell invoice-row invoice-summary-cell">
                            {data.paymentDueDate}
                        </td>
                    </tr>
                </tbody>
                </table>
                <br />
                <br />
            
         
                <table className="invoice-table">
                    <tbody>
                           {this.props.profile?.type === ProfileType.Agent.ordinal && data.superFee > 0 ? 
            <React.Fragment>
                          <tr style={{backgroundColor: "#D9D9D9"}}>
                <td class="bordered-cell">
                    Description
                </td>
                <td class="bordered-cell">
                        GST rate
                </td>
                <td class="bordered-cell">
                        Quoted gig fee (inc. super)
                </td>
                <td class="bordered-cell">
                        Super component (info only)
                </td>
                <td class="bordered-cell">
                        GST base (ex-super)
                </td>
                <td class="bordered-cell">
                    {data.taxLabel}
                </td>
            </tr>
            </React.Fragment> : 
            <React.Fragment>
                    <tr style={{backgroundColor: "#D9D9D9"}}>
                <td class="bordered-cell">
                    Description
                </td>
                <td class="bordered-cell">
                        {data.taxLabel}
                </td>
                <td class="bordered-cell">
                        Fee
                </td>
            </tr>
            </React.Fragment>

            }
                        {this.props.profile?.type === ProfileType.Agent.ordinal && data.superFee > 0 ? 
                        data.invoiceLines.map(invoice => {
                            return <tr className="bordered-cell invoice-row-description">
                                 <td class="bordered-cell invoice-row">
                                    {invoice.descriptionNew}
                                </td>
                                <td class="pull-center bordered-cell invoice-row invoice-row-fee-detail">
                                    {data.taxLabel}
                                </td>
                                <td style={{textAlign:"right"}} class="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.fee}
                                </td>
                                <td style={{textAlign:"right"}} class="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.superFee}
                                </td>
                                <td style={{textAlign:"right"}} class="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.feeWithoutSuper}
                                </td>
                                <td style={{textAlign:"right"}} class="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.taxValue}
                                </td>

                                {/* <td className="bordered-cell invoice-row">
                                    {`${invoice.description} - ${moment(invoice.date).format("DD/MM/YYYY")} - ${invoice.timeStart} to ${invoice.timeEnd}`}
                                </td>
                                <td className="bordered-cell invoice-row invoice-row-fee-detail">
                                    {data.taxLabel}
                                </td>
                                <td className="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.fee}
                                </td> */}
                            </tr>
                        }) : data.invoiceLines.map(invoice => {
                            return <tr className="bordered-cell invoice-row-description">
                                <td className="bordered-cell invoice-row">
                                    {`${invoice.description} - ${moment(invoice.date).format("DD/MM/YYYY")} - ${invoice.timeStart} to ${invoice.timeEnd}`}
                                </td>
                                <td className="bordered-cell invoice-row invoice-row-fee-detail">
                                    {data.taxLabel}
                                </td>
                                <td className="bordered-cell invoice-row invoice-row-fee-detail">
                                    {invoice.fee}
                                </td>
                            </tr>
                        })}
                        {
                            this.props.profile?.type === ProfileType.Agent.ordinal && data.superFee > 0 ?
                            
                            <tr className="bordered-cell invoice-row-description">
                                 <td class="bordered-cell invoice-row">
                                    Superannuation (aggregated)
                                </td>
                                <td class="bordered-cell pull-center invoice-row invoice-row-fee-detail">
                                    (GST Free)
                                </td>
                                <td class="bordered-cell invoice-row invoice-row-fee-detail">
                                
                                </td>
                                <td class="bordered-cell invoice-row invoice-row-fee-detail">
                                    {data.superFeeString}
                                </td>
                                <td class="bordered-cell invoice-row invoice-row-fee-detail">
                                
                                </td>
                                <td class="bordered-cell invoice-row invoice-row-fee-detail">
                                
                                </td>
                            </tr>
                            
                            : null
                        }
                        {
                            this.props.profile?.type === ProfileType.Agent.ordinal && data.superFee > 0 ? 
                            <React.Fragment>
                                 <tr>
                <td colspan="5" class="invoice-summary-cell invoice-row">
                    Gig fees subtotal (incl super)
            </td>
                <td class="bordered-cell invoice-row-fee-detail invoice-row">
                    {data.invoiceSubTotalWithSuper}
                </td>
            </tr>
            <tr>
              
                <td colspan="5" class="invoice-summary-cell invoice-row">
                    GST base subtotal (ex-Super)
            </td>
                <td class="bordered-cell invoice-row-fee-detail invoice-row">
                    {data.totalWithoutSuperString}
                </td>
            </tr>
            <tr>
                <td colspan="5"  class="invoice-summary-cell invoice-row">
                    {data.taxLabel} (on GST base only)
                </td>
                <td class="bordered-cell invoice-row-fee-detail invoice-row">
                    {data.invoiceTax}
                </td>
            </tr>
            <tr>
                <td colspan="5"  class="invoice-summary-cell invoice-row">
                    Amount payable (fees + GST)
            </td>
                <td class="bordered-cell invoice-row-fee-detail invoice-row">
                    {data.invoiceTotalWithSuper}
                </td>
            </tr>
                            </React.Fragment> : 
                            <React.Fragment>
                                 <tr>
                            <td>
                                &nbsp;
              </td>
                            <td className="invoice-summary-cell invoice-row">
                                Total
              </td>
                            <td className="bordered-cell invoice-row-fee-detail invoice-row">
                                {data.invoiceSubTotal}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                &nbsp;
              </td>
                            <td className="invoice-summary-cell invoice-row">
                                {data.taxLabel}
                            </td>
                            <td className="bordered-cell invoice-row-fee-detail invoice-row">
                                {data.invoiceTax}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                &nbsp;
              </td>
                            <td className="invoice-summary-cell invoice-row">
                                Invoice Total
              </td>
                            <td className="bordered-cell invoice-row-fee-detail invoice-row">
                                {data.invoiceTotal}
                            </td>
                        </tr>
                                
                            </React.Fragment>
                        }
                        
                       
                    </tbody></table >
                <table>
                    <tbody><tr>
                        <td className="payment-to">
                            Please make payments to:
              </td>
                    </tr>
                        <tr>
                            <td className="payment-to">
                                Bank Account Name: {data.paymentReceiverAccountName}
                            </td>
                        </tr>
                        <tr>
                            <td className="payment-to">
                                BSB: {data.paymentReceiverBSB}
                            </td>
                        </tr>
                        <tr>
                            <td className="payment-to">
                                Account Number: {data.paymentReceiverAccountNumber}
                            </td>
                        </tr>
              
                    </tbody></table>


                  {parseFloat(data?.superFee) > 0 && this.props.profile?.type === ProfileType.Musician.ordinal ? 
                         <table style={{marginTop:20}}>
                                    <tr>
                                        <td class="payment-to">
                                            Superannuation Guarantee (SG) Payable:
                                        </td>
                                    </tr>
                                <tr>
                                        <td class="payment-to">
                                            {`$${parseFloat(data?.superFee).toFixed(2)} (at ${parseFloat(12).toFixed(2)}%) — to be paid directly to the nominated super fund below.`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="payment-to">
                                            {`Super Fund: ${data?.payee?.superAnnuationProfile?.fundName} - ${data?.payee?.superAnnuationProfile.productName}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="payment-to">
                                            {`ABN: ${data?.payee?.superAnnuationProfile?.aBN}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="payment-to">
                                            {`USI: ${data?.payee?.superAnnuationProfile?.uSI}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="payment-to">
                                            {`Member Number: ${data?.payee?.superAnnuationProfile?.superFundMemberNumber}`}
                                        </td>
                                    </tr>
                                </table> :  null}
                                
            </Grid >
        );
    }
}

export default ClientInvoice;
